import { EmailTemplate } from "../../types/features/administration/EmailTemplate";
import { TemplateDefault } from "./TemplateDefault";
import { TemplateSimple } from "./TemplateSimple";
import { TemplateDailyRates } from "./TemplateDailyRates";

export const templatesList: EmailTemplate[] = [TemplateDefault, TemplateSimple, TemplateDailyRates];
